import { BridgeComponent } from "@hotwired/hotwire-native-bridge"

// Registers this device for push notifications (sindi-ios PushComponent.swift).
// Rendered on every signed-in mobile page by the mobile layouts, and loads
// only when the shell advertises the "push" bridge component. The native
// side asks for notification permission, registers with APNs and replies
// with the token; the page stores it through DeviceTokensController so the
// request carries the user's session and CSRF token.
export default class extends BridgeComponent {
  static component = "push"

  connect() {
    super.connect()
    this.send("register", {}, (message) => this.store(message.data))
  }

  async store(data) {
    const token = data?.token
    if (!token) return

    // One registration per app launch is plenty; every tab root re-renders this.
    const signature = `${token}:${data.environment}:${data.appVersion}`
    if (window.sindiRegisteredPushToken === signature) return

    try {
      const response = await fetch("/device_tokens", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content || ""
        },
        body: JSON.stringify({
          token,
          platform: "ios",
          environment: data.environment,
          bundle_id: data.bundleId,
          app_version: data.appVersion
        })
      })
      if (response.ok) window.sindiRegisteredPushToken = signature
    } catch (error) {
      console.warn("[bridge--push] registration failed", error)
    }
  }
}
